import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=2b7cec60&scoped=true&"
import script from "./member-list.vue?vue&type=script&lang=js&"
export * from "./member-list.vue?vue&type=script&lang=js&"
import style0 from "./member-list.vue?vue&type=style&index=0&id=2b7cec60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cec60",
  null
  
)

export default component.exports